module.exports = __webpack_public_path__ + "img/logo-nsc.7472d31a.jpg";